module.exports = __webpack_public_path__ + "img/lv8.3ea810ec.png";